import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { SprintPacketSurveyStatus } from '@marketing-milk/interfaces'
import { radius, SurfacePalette, type } from '../../../tokens'
import { sectionNumberFor } from '../../sections'
import { PresentPage } from '../PresentPage'

interface Props {
  palette: SurfacePalette
  packetID: number
  survey: SprintPacketSurveyStatus
}

// Present-mode survey slide: big QR + live Submitted COUNT only. Respondent
// names never render on the projector — someone in the room shouldn't see
// themselves identified; names live in Edit. Read-only, so no PresentNavLock.
export const PresentClientSurveySection = ({ palette, packetID, survey }: Props) => (
  <PresentPage
    palette={palette}
    number={sectionNumberFor('client-survey')}
    title="Client Survey"
    accentWord="Survey"
    commentAnchor={{ type: 'section', id: `${packetID}:client-survey`, label: 'Client Survey' }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 56,
        paddingTop: 12,
      }}
    >
      <div
        style={{
          flexShrink: 0,
          padding: 20,
          borderRadius: radius.lg,
          background: '#fff',
        }}
      >
        <QRCodeSVG value={survey.link} size={280} />
      </div>
      <div style={{ maxWidth: 440 }}>
        <div
          style={{
            fontFamily: type.family.serif,
            fontSize: type.size.h2,
            color: palette.text,
            marginBottom: 8,
          }}
        >
          Scan to share your feedback
        </div>
        <p
          style={{
            margin: 0,
            fontFamily: type.family.sans,
            fontSize: type.size.body,
            color: palette.textMuted,
            lineHeight: 1.5,
          }}
        >
          Answer privately on your own phone — your responses go straight to our Client Success team
          and never appear on this screen.
        </p>
        <div
          style={{
            marginTop: 24,
            display: 'inline-flex',
            alignItems: 'baseline',
            gap: 10,
            padding: '10px 20px',
            borderRadius: 999,
            border: `1px solid ${palette.hairline}`,
            background: palette.surface,
          }}
        >
          <span
            style={{
              fontFamily: type.family.serif,
              fontSize: type.size.h2,
              color: palette.accent,
            }}
          >
            {survey.responses.length}
          </span>
          <span
            style={{
              fontFamily: type.family.mono,
              fontSize: type.size.eyebrow,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: palette.textMuted,
            }}
          >
            Submitted
          </span>
        </div>
      </div>
    </div>
  </PresentPage>
)
